// ** MUI Imports
import {
    Box,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    MenuItem,
  } from "@mui/material";
  import { useTheme } from "@mui/material/styles";
  
  // ** Custom Component Imports
  import CustomTextField from "components/mui/text-field";
  import CustomAutocomplete from "components/mui/autocomplete";
import { useEffect, useState } from "react";

  const AddTermsNConditions = ({ open, handleClose, onSave, initialData, MODULES }) => {
    const theme = useTheme();

    // const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [moduleName, setModuleName] = useState(MODULES[0].value);
    const [errors, setErrors] = useState({});


    useEffect(() => {
      if (initialData) {
        // setTitle(initialData.title || "");
        setDescription(initialData.description || "");
        setModuleName(initialData.moduleName || MODULES[0].value); // default to first module if missing
      } else {
        // setTitle("");
        setDescription("");
        setModuleName(MODULES[0].value); // always default to first for new
      }
    }, [initialData, open]);

    const handleSubmit = () => {
      
      const newErrors = {};
      if (!description.trim()) newErrors.description = "Terms are required";
      if (!moduleName) newErrors.moduleName = "Module is required";
    
      setErrors(newErrors);
    
      if (Object.keys(newErrors).length > 0) return;

      const payload = {
        termID: initialData?.termID || 0, // 0 for add, ID for edit
        moduleName: moduleName,
        terms: description
      };
      onSave(payload);
    };

    return (
      <>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle
            sx={{
              borderBottom: "1px solid #D9D9D9",
              paddingBottom: "20px !important",
            }}
          >
            <Box>
              <Typography variant="h4" fontWeight="bold">
                {initialData ? "Edit" : "Add New"} - Service Terms & Conditions
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={5}>
              {/* <Grid item xs={12} md={8}>
                <CustomTextField
                  fullWidth
                  required
                  label="Title"
                  placeholder="Enter title"
                  value={title}
                  onChange={e => setTitle(e.target.value)}
                  error={!!errors.title}
                  helperText={errors.title}
                />
              </Grid> */}
              <Grid item xs={12} md={8}>
                <CustomTextField
                  fullWidth
                  required
                  multiline
                  rows={2}
                  label="Terms and Conditions"
                  placeholder="Add Description"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  error={!!errors.description}
                  helperText={errors.description}
                />
              </Grid>
              <Grid item xs={12} md={8}>
              <CustomAutocomplete
                fullWidth
                required
                options={MODULES
                  .slice()
                  .sort((a, b) => a.label.localeCompare(b.label))
                }
                value={MODULES.find(mod => mod.value === moduleName) || null}
                onChange={(event, newValue) => {
                  setModuleName(newValue?.value || '');
                }}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.value === value?.value}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    label="Module Name"
                    placeholder="Select Module Name"
                    required
                    error={!!errors.moduleName}
                    helperText={errors.moduleName}
                  />
                )}
                PaperProps={{
                  sx: {
                    maxHeight: 200
                  }
                }}
              />
            </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: "20px 24px !important",
              boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`,
              zIndex: 1,
            }}
            className="dialog-actions-dense"
          >
            <Box>
              <Button variant="contained" color="info" onClick={handleClose}>
                Cancel
              </Button>
            </Box>
            <Box>
            <Button variant="contained" color="main" onClick={handleSubmit}>
              {initialData ? "Save Changes" : "Save"}
            </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </>
    );
  };
  
  export default AddTermsNConditions;
  